// List of icons: https://vue-feather-icons.egoist.sh/
import { FilterIcon, RadioIcon, PaperclipIcon, TypeIcon, CopyIcon, ChevronDownIcon, ChevronUpIcon, InfoIcon, ClipboardIcon, AlertTriangleIcon, AlertCircleIcon, MonitorIcon, BellIcon, SettingsIcon, MenuIcon, UserIcon, ArrowLeftIcon, ArrowUpIcon, ArrowDownIcon, Link2Icon, ChevronRightIcon, TagIcon, LayersIcon, GitPullRequestIcon, ChevronsRightIcon, BarChart2Icon, CheckIcon, FileTextIcon, DownloadIcon, XCircleIcon, CheckCircleIcon, LogInIcon, LogOutIcon, XIcon, Trash2Icon, CheckSquareIcon, CommandIcon, PrinterIcon, AlertOctagonIcon, LockIcon, Edit3Icon, MoreHorizontalIcon, GridIcon, CpuIcon, EditIcon, CalendarIcon, SearchIcon, SlidersIcon, MapIcon, RepeatIcon, MapPinIcon, EyeIcon, EyeOffIcon, ArchiveIcon, PlusCircleIcon, FilePlusIcon, SunIcon, SaveIcon, ClockIcon, MaximizeIcon, MinimizeIcon, ArrowLeftCircleIcon, ArrowRightCircleIcon, HomeIcon, Minimize2Icon, Maximize2Icon, Volume2Icon, VolumeXIcon, ZoomInIcon, ZoomOutIcon, ImageIcon, ZapIcon, ZapOffIcon, ExternalLinkIcon, UserXIcon, HelpCircleIcon } from "vue-feather-icons";

function camelToKebab (name) {
	return name.substr(0, name.length - 4).replace(/([A-Z])/g, "-$1").toLowerCase();
}

function genIcon (name, children, flip = false) {
	return {
		name,
		props: {
			size: {
				type: String,
				default: "24",
				validator: function validator (s) {
					return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === "x";
				}
			}
		},
		functional: true,
		render: function render (h, ctx) {
			const size = ctx.props.size.slice(-1) === "x" ? ctx.props.size.slice(0, ctx.props.size.length - 1) + "em" : parseInt(ctx.props.size) + "px";
			const attrs = ctx.data.attrs || {};
			attrs.width = attrs.width || size;
			attrs.height = attrs.height || size;
			ctx.data.attrs = attrs;
			return h("svg", {
				attrs: {
					xmlns: "http://www.w3.org/2000/svg",
					width: "24",
					height: "24",
					viewBox: "0 0 24 24",
					fill: flip ? "currentColor" : "none",
					stroke: flip ? "none" : "currentColor",
					"stroke-width": "2",
					"stroke-linecap": "round",
					"stroke-linejoin": "round"
				},
				class: `feather feather${camelToKebab(name)}`,
				...ctx.data
			}, children(h));
		}
	};
}

const DashboardIcon = genIcon("DashboardIcon", h => [h("path", {
	attrs: {
		d: "M12.984 3h8.016v6h-8.016v-6zM12.984 21v-9.984h8.016v9.984h-8.016zM3 21v-6h8.016v6h-8.016zM3 12.984v-9.984h8.016v9.984h-8.016z"

	}
})], true);

const LineChartIcon = genIcon("LineChartIcon", h => [h("path", {
	attrs: {
		d: "M22 11h-4c-0.4 0-0.8 0.3-0.9 0.7l-2.1 6.1-5.1-15.1c-0.1-0.4-0.5-0.7-0.9-0.7s-0.8 0.3-0.9 0.7l-2.8 8.3h-3.3c-0.6 0-1 0.4-1 1s0.4 1 1 1h4c0.4 0 0.8-0.3 0.9-0.7l2.1-6.1 5.1 15.2c0.1 0.4 0.5 0.7 0.9 0.7s0.8-0.3 0.9-0.7l2.8-8.3h3.3c0.6 0 1-0.4 1-1s-0.4-1.1-1-1.1z",
		fill: "currentColor"
	}
})]);

const BlurLinearIcon = genIcon("BlurLinearIcon", h => [h("path", {
	attrs: {
		d: "M12.984 17.016c-0.563 0-0.984-0.469-0.984-1.031s0.422-0.984 0.984-0.984 1.031 0.422 1.031 0.984-0.469 1.031-1.031 1.031zM12.984 12.984c-0.563 0-0.984-0.422-0.984-0.984s0.422-0.984 0.984-0.984 1.031 0.422 1.031 0.984-0.469 0.984-1.031 0.984zM12.984 9c-0.563 0-0.984-0.422-0.984-0.984s0.422-1.031 0.984-1.031 1.031 0.469 1.031 1.031-0.469 0.984-1.031 0.984zM17.016 12.516c-0.281 0-0.516-0.234-0.516-0.516s0.234-0.516 0.516-0.516 0.469 0.234 0.469 0.516-0.188 0.516-0.469 0.516zM17.016 8.484c-0.281 0-0.516-0.188-0.516-0.469s0.234-0.516 0.516-0.516 0.469 0.234 0.469 0.516-0.188 0.469-0.469 0.469zM3 3h18v2.016h-18v-2.016zM17.016 16.5c-0.281 0-0.516-0.234-0.516-0.516s0.234-0.469 0.516-0.469 0.469 0.188 0.469 0.469-0.188 0.516-0.469 0.516zM9 17.016c-0.563 0-0.984-0.469-0.984-1.031s0.422-0.984 0.984-0.984 0.984 0.422 0.984 0.984-0.422 1.031-0.984 1.031zM5.016 13.5c-0.844 0-1.5-0.656-1.5-1.5s0.656-1.5 1.5-1.5 1.5 0.656 1.5 1.5-0.656 1.5-1.5 1.5zM5.016 9.516c-0.844 0-1.5-0.656-1.5-1.5s0.656-1.5 1.5-1.5 1.5 0.656 1.5 1.5-0.656 1.5-1.5 1.5zM3 21v-2.016h18v2.016h-18zM9 9c-0.563 0-0.984-0.422-0.984-0.984s0.422-1.031 0.984-1.031 0.984 0.469 0.984 1.031-0.422 0.984-0.984 0.984zM9 12.984c-0.563 0-0.984-0.422-0.984-0.984s0.422-0.984 0.984-0.984 0.984 0.422 0.984 0.984-0.422 0.984-0.984 0.984zM5.016 17.484c-0.844 0-1.5-0.656-1.5-1.5s0.656-1.5 1.5-1.5 1.5 0.656 1.5 1.5-0.656 1.5-1.5 1.5z",
		fill: "currentColor"
	}
})]);

const OCheckNetworkIcon = genIcon("OCheckNetworkIcon", h => [h("path", {
	attrs: {
		d: "M14.25 18.6667C14.25 18.3793 14.1358 18.1038 13.9327 17.9006C13.7295 17.6975 13.4539 17.5833 13.1666 17.5833H12.0833V15.4167H16.4166C16.9913 15.4167 17.5424 15.1884 17.9487 14.7821C18.355 14.3757 18.5833 13.8246 18.5833 13.25V2.41667C18.5833 1.84203 18.355 1.29093 17.9487 0.884602C17.5424 0.478273 16.9913 0.25 16.4166 0.25H5.58329C5.00866 0.25 4.45756 0.478273 4.05123 0.884602C3.6449 1.29093 3.41663 1.84203 3.41663 2.41667V13.25C3.41663 13.8246 3.6449 14.3757 4.05123 14.7821C4.45756 15.1884 5.00866 15.4167 5.58329 15.4167H9.91663V17.5833H8.83329C8.54597 17.5833 8.27042 17.6975 8.06726 17.9006C7.8641 18.1038 7.74996 18.3793 7.74996 18.6667H0.166626V20.8333H7.74996C7.74996 21.1206 7.8641 21.3962 8.06726 21.5994C8.27042 21.8025 8.54597 21.9167 8.83329 21.9167H13.1666C13.4539 21.9167 13.7295 21.8025 13.9327 21.5994C14.1358 21.3962 14.25 21.1206 14.25 20.8333H21.8333V18.6667H14.25ZM5.58329 13.25V2.41667H16.4166V13.25H5.58329ZM6.66663 8.23417L8.00996 6.89083L9.84079 8.7325L13.99 4.58333L15.3333 6.20833L9.84079 11.7008L6.66663 8.23417Z",
		fill: "currentColor"
	}
})]);

const AppsIcon = genIcon("AppsIcon", h => [h("path", {
	attrs: {
		d: "M15.984 20.016v-4.031h4.031v4.031h-4.031zM15.984 14.016v-4.031h4.031v4.031h-4.031zM9.984 8.016v-4.031h4.031v4.031h-4.031zM15.984 3.984h4.031v4.031h-4.031v-4.031zM9.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 14.016v-4.031h4.031v4.031h-4.031zM3.984 20.016v-4.031h4.031v4.031h-4.031zM9.984 20.016v-4.031h4.031v4.031h-4.031zM3.984 8.016v-4.031h4.031v4.031h-4.031z",
		fill: "currentColor"
	}
})]);

const BanIcon = genIcon("BanIcon", h => [h("path", {
	attrs: {
		d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-8-8A7.92,7.92,0,0,1,5.69,7.1L16.9,18.31A7.92,7.92,0,0,1,12,20Zm6.31-3.1L7.1,5.69A7.92,7.92,0,0,1,12,4a8,8,0,0,1,8,8A7.92,7.92,0,0,1,18.31,16.9Z",
		fill: "currentColor"
	}

})]);

const QuestionIcon = genIcon("QuestionIcon", h => [h("path", {
	attrs: {
		d: "M16.8594854,20.7417567 C15.3870177,21.5619833 13.7245582,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,13.7245582 21.5619833,15.3870177 20.7417567,16.8594854 L21.0946904,21.0946904 L16.8594854,20.7417567 Z M16.3916038,18.6958341 L18.9053096,18.9053096 L18.6958341,16.3916038 L18.8621131,16.1149882 C19.6030308,14.8824253 20,13.4715357 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C13.4715357,20 14.8824253,19.6030308 16.1149882,18.8621131 L16.3916038,18.6958341 Z M12.0003283,16.9983464 C11.4478622,16.9983464 11,16.5506311 11,15.9983464 C11,15.4460616 11.4478622,14.9983464 12.0003283,14.9983464 C12.5527943,14.9983464 13.0006565,15.4460616 13.0006565,15.9983464 C13.0006565,16.5506311 12.5527943,16.9983464 12.0003283,16.9983464 Z M13,14 L11,14 L11,13 C11,12.2626932 11.3827392,11.7004784 11.9774877,11.2286498 C12.1564111,11.0867055 12.2101653,11.0510845 12.5339634,10.8458119 C12.8225361,10.6628706 13,10.3473166 13,10 C13,9.44771525 12.5522847,9 12,9 C11.4477153,9 11,9.44771525 11,10 L9,10 C9,8.34314575 10.3431458,7 12,7 C13.6568542,7 15,8.34314575 15,10 C15,11.0395627 14.4660508,11.988994 13.6048137,12.5349773 C13.3517279,12.6954217 13.3206582,12.7160104 13.2204897,12.7954765 C13.0562911,12.9257393 13,13.0084267 13,13 L13,14 Z",
		fill: "currentColor"
	}

})]);

const GlobeWarningIcon = genIcon("GlobeWarningIcon", h => [
	h("path", {
		attrs: {
			d: "M8.30445 11.947C7.50977 11.947 6.76806 11.947 5.97337 11.947C5.33762 11.947 4.91379 11.5762 4.75485 10.9934C4.70187 10.7285 4.75485 10.4636 4.86081 10.2517C5.6555 8.66233 6.45018 7.07296 7.24487 5.48359C7.45679 5.05976 7.82764 4.84784 8.30445 4.84784C8.78126 4.84784 9.15212 5.05976 9.36404 5.48359C10.1587 7.07296 10.9534 8.66233 11.7481 10.2517C12.1719 11.0994 11.5892 11.947 10.6355 12C9.89383 11.947 9.09914 11.947 8.30445 11.947ZM7.9336 8.13254C7.9336 8.45042 7.9336 8.76829 7.9336 9.08617C7.9336 9.35106 8.09254 9.51 8.35743 9.51C8.56935 9.51 8.72829 9.35106 8.72829 9.08617C8.72829 8.45042 8.72829 7.81467 8.72829 7.17892C8.72829 6.91402 8.56935 6.75509 8.35743 6.75509C8.14552 6.75509 7.9336 6.91402 7.9336 7.17892C7.9336 7.49679 7.9336 7.81467 7.9336 8.13254ZM8.72829 10.3577C8.72829 10.1457 8.56935 9.98681 8.35743 9.98681C8.14552 9.98681 7.98658 10.1457 7.9336 10.3577C7.9336 10.5696 8.09254 10.7815 8.35743 10.7815C8.51637 10.7285 8.72829 10.5696 8.72829 10.3577Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M3.96021 3.57632C4.06616 2.94057 4.2251 2.3578 4.43702 1.77503C4.59595 1.29822 4.80787 0.874384 5.17872 0.50353C5.28468 0.397572 5.39064 0.291614 5.4966 0.185655C5.76149 -0.026261 6.07937 -0.026261 6.39724 0.185655C6.55618 0.291614 6.71512 0.450551 6.82108 0.609488C7.24491 1.13928 7.45683 1.77503 7.66874 2.41078C7.7747 2.78163 7.82768 3.20546 7.93364 3.57632C6.60916 3.57632 5.28468 3.57632 3.96021 3.57632Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M3.05954 4.42397C2.95358 5.48355 2.95358 6.54313 3.05954 7.60271C3.00656 7.60271 2.95358 7.60271 2.95358 7.60271C2.10592 7.60271 1.20527 7.60271 0.357609 7.60271C0.251651 7.60271 0.251651 7.60271 0.198672 7.49676C-0.0662239 6.49015 -0.0662239 5.53653 0.198672 4.52993C0.198672 4.47695 0.251651 4.42397 0.30463 4.42397C1.20527 4.42397 2.10592 4.42397 3.00656 4.42397C3.00656 4.37099 3.00656 4.42397 3.05954 4.42397Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M3.85413 7.54975C3.74817 6.49017 3.74817 5.43058 3.85413 4.371C4.91371 4.371 6.02627 4.371 7.13883 4.371C6.715 4.68888 6.50308 5.16569 6.29116 5.6425C5.97329 6.22527 5.7084 6.86102 5.39052 7.44379C5.33754 7.49677 5.33754 7.54975 5.23158 7.54975C4.75477 7.54975 4.27796 7.54975 3.85413 7.54975Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M11.3773 3.57628C11.3243 3.57628 11.2713 3.57628 11.2713 3.57628C10.4767 3.57628 9.62899 3.57628 8.8343 3.57628C8.72835 3.57628 8.72834 3.57628 8.67537 3.47033C8.51643 2.56968 8.30451 1.66904 7.88068 0.821372C7.77472 0.609455 7.66876 0.450518 7.56281 0.238602C7.98664 0.238602 9.20516 0.92733 9.84091 1.45712C10.5296 2.09287 11.0064 2.7816 11.3773 3.57628Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M0.463623 3.57628C1.25831 1.88095 2.52981 0.768393 4.27812 0.238602C3.96024 0.715414 3.69535 1.29818 3.53641 1.82797C3.37747 2.41074 3.27152 2.99351 3.11258 3.57628C2.26491 3.57628 1.36427 3.57628 0.463623 3.57628Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M4.11918 11.6821C2.42385 11.0993 1.20533 9.98677 0.463623 8.3974C0.516602 8.3974 0.569581 8.3974 0.569581 8.3974C1.36427 8.3974 2.21193 8.3974 3.00662 8.3974C3.11258 8.3974 3.11258 8.3974 3.16556 8.50336C3.32449 9.404 3.53641 10.3046 3.96024 11.0993C4.0662 11.2583 4.0662 11.4702 4.11918 11.6821Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M9.52301 4.371C9.73493 4.371 9.89386 4.371 10.0528 4.371C10.5296 4.371 11.0594 4.371 11.5362 4.371C11.5892 4.371 11.6422 4.371 11.6952 4.47696C11.96 5.48356 11.96 6.43719 11.6952 7.44379C11.6952 7.54975 11.6422 7.54975 11.5362 7.54975C11.3773 7.54975 11.2713 7.49677 11.2183 7.33783C10.9005 6.6491 10.5296 5.9074 10.1588 5.21867C9.99982 4.95377 9.84088 4.6359 9.52301 4.371Z",
			fill: "#535353"
		}
	}),
	h("path", {
		attrs: {
			d: "M4.22504 9.61595C4.11908 9.19212 4.01312 8.76828 3.90717 8.34445C4.22504 8.34445 4.54291 8.34445 4.86079 8.34445C4.70185 8.82126 4.48994 9.19212 4.22504 9.61595Z",
			fill: "#535353"
		}
	})
]);


/**
 * @param {import("vue").VueConstructor} Vue
 */
export function install (Vue) {
	if (install.installed) return;
	install.installed = true;

	const icons = [
		HelpCircleIcon,
		BellIcon,
		SettingsIcon,
		MenuIcon,
		UserIcon,
		ArrowLeftIcon,
		ArrowUpIcon,
		ArrowDownIcon,
		DashboardIcon,
		GlobeWarningIcon,
		Link2Icon,
		ChevronRightIcon,
		TagIcon,
		LayersIcon,
		GitPullRequestIcon,
		ChevronsRightIcon,
		BarChart2Icon,
		CheckIcon,
		XIcon,
		FileTextIcon,
		DownloadIcon,
		XCircleIcon,
		CheckCircleIcon,
		LogInIcon,
		LogOutIcon,
		Trash2Icon,
		CheckSquareIcon,
		CommandIcon,
		PrinterIcon,
		AlertOctagonIcon,
		AlertCircleIcon,
		LockIcon,
		Edit3Icon,
		MoreHorizontalIcon,
		GridIcon,
		CpuIcon,
		EditIcon,
		CalendarIcon,
		LineChartIcon,
		BlurLinearIcon,
		OCheckNetworkIcon,
		AppsIcon,
		BanIcon,
		SearchIcon,
		SlidersIcon,
		MapIcon,
		RepeatIcon,
		MapPinIcon,
		EyeIcon,
		EyeOffIcon,
		ArchiveIcon,
		PlusCircleIcon,
		FilePlusIcon,
		SunIcon,
		SaveIcon,
		MonitorIcon,
		AlertTriangleIcon,
		ClipboardIcon,
		ClockIcon,
		InfoIcon,
		MaximizeIcon,
		MinimizeIcon,
		Maximize2Icon,
		Minimize2Icon,
		ArrowLeftCircleIcon,
		ArrowRightCircleIcon,
		CopyIcon,
		TypeIcon,
		HomeIcon,
		PaperclipIcon,
		Volume2Icon,
		VolumeXIcon,
		ZoomInIcon,
		ZoomOutIcon,
		ImageIcon,
		ZapIcon,
		ZapOffIcon,
		ExternalLinkIcon,
		ChevronDownIcon,
		ChevronUpIcon,
		FilterIcon,
		RadioIcon,
		UserXIcon,
		QuestionIcon
	];

	for (const icon of icons)
		Vue.component(icon.name, icon);
}

export default { install };
